import { render, staticRenderFns } from "./SPListComponent.vue?vue&type=template&id=673a7cde&scoped=true&"
import script from "./SPListComponent.vue?vue&type=script&lang=js&"
export * from "./SPListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a7cde",
  null
  
)

export default component.exports